import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import {addLocale, locale, PrimeReactProvider} from 'primereact/api';
import 'primereact/resources/primereact.css';
import {FC, ReactNode, useEffect} from 'react';
import localization from '../locale/localization.json';
import {userPreferredLocale} from '../utils';

interface Props {
  children: ReactNode;
}
const GlobalProvider: FC<Props> = ({children}) => {
  useEffect(() => {
    addLocale('en', {...localization.en});
    addLocale('tr', {...localization.tr});

    locale(userPreferredLocale);
  }, []);

  return <PrimeReactProvider>{children}</PrimeReactProvider>;
};

export default GlobalProvider;
